import { fetchData } from '../fetchapi/fetchapi';

// RULES STUDIO ASSISTANT — draft a processing rule from plain language.
//
// The Rules Studio asks a customer to hand-write rule_code against an engine
// envelope ({isValid, transformedValue, message}) that the panel never shows
// them; getting it wrong fails the whole pipeline silently. This turns a
// sentence into a complete drafted rule instead.
//
// DRAFT ONLY — the response is never persisted by this call. The panel previews
// it and the user's Apply click goes through the ordinary processing_rule save,
// so nothing is written without confirmation.
//
// body:
//   instruction  (required) what the rule should do, or what to change
//   current      (optional) the rule being edited — { rule_name, description,
//                rule_code, rule_language, rule_type, input_type }. Present =>
//                an EDIT (the draft preserves what the instruction doesn't touch).
//   context      (optional) { element_name, element_type, element_description,
//                elements[], source_fields[], sample_values[] } — what the rule
//                runs on, so the draft matches the project's real data.
// → { draft: { rule_name, description, rule_type, rule_language, input_type,
//     rule_code, summary, test_cases: [{ name, input, expected, description }] },
//     is_edit }
export async function draftProcessingRule(body) {
  return fetchData('rule_assistant/draft', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
